<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <h4>Cable</h4>
        <v-card flat class="card1">
          <small
            >Select Decoder : <b class="selected">{{ network }}</b></small
          >
          <v-card flat class="cardDiv">
            <div @click="Setnetwork('DSTV')" class="network">
              <img
                src="../assets/dstv.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('GOTV')" class="network">
              <img
                src="../assets/gotv.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('StarTimes')" class="network">
              <img
                src="../assets/startimes.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
          </v-card>
          <v-row>
            <v-col>
              <div
                v-if="network == 'DSTV' || network == 'GOTV'"
                class="labelDiv"
              >
                <label><b>Select Bundle</b></label>
              </div>
              <div v-if="network == 'DSTV'" class="selectDiv">
                <v-select
                  v-model="serviceCode"
                  item-text="title"
                  item-value="code"
                  :items="DstvBundle"
                  solo
                  append-icon="mdi-menu-down"
                >
                </v-select>
              </div>
              <div v-if="network == 'GOTV'" class="selectDiv">
                <v-select
                  v-model="serviceCode"
                  item-text="title"
                  item-value="code"
                  :items="GotvBundle"
                  solo
                  append-icon="mdi-menu-down"
                >
                </v-select>
              </div>
              <div class="labelDiv">
                <label><b>Smartcard Number</b></label>
              </div>
              <v-text-field
                type="number"
                v-model="SmartCard"
                outlined
              ></v-text-field>
              <div class="labelDiv">
                <label><b>Customer Phone number</b></label>
              </div>
              <v-text-field
                type="number"
                v-model="customerPhone"
                outlined
              ></v-text-field>
              <div v-if="network == 'StarTimes'" class="labelDiv">
                <label><b>Amount</b></label>
              </div>
              <v-text-field
                v-if="network == 'StarTimes'"
                type="number"
                v-model="amount"
                outlined
              ></v-text-field>
              <v-btn block class="nextBtn" dark @click="loadCardDetail()">
                Next
              </v-btn>
            </v-col>
          </v-row>
          <v-dialog v-model="CableDialog" persistent max-width="500">
            <CableDetail
              :serviceCode="serviceCode"
              :customerPhone="customerPhone"
              :SmartCard="SmartCard"
              :amount="amount"
              :network="network"
            />
          </v-dialog>
        </v-card>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import CableDetail from "../components/CableDetail";

export default {
  created() {
    this.getCableBundle();
  },
  metaInfo: {
    title: "Teller/Cable",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    CableDetail: CableDetail,
  },
  computed: {
    CableDialog() {
      return this.$store.getters.getCableDialog;
    },
    GotvBundle() {
      return this.$store.getters.getCableGotvBundle;
    },
    DstvBundle() {
      return this.$store.getters.getCableDstvBundle;
    },
  },
  data() {
    return {
      amount: "",
      dialog: false,
      SmartCard: "",
      customerPhone: "",
      network: "DSTV",
      serviceCode: "",
    };
  },
  methods: {
    Setnetwork(payload) {
      console.log(payload);
      if (payload == "StarTimes") {
        this.serviceCode = "StarTimes";
      }
      this.network = payload;
    },
    getCableBundle() {
      this.$store.dispatch("getCableBundle");
    },
    loadCardDetail() {
      if (this.SmartCard == "" || this.customerPhone == "") {
        let payload = {
          status: true,
          message: "Fill out all the required fields",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        network: this.network,
        serviceCode: this.serviceCode,
        SmartCard: this.SmartCard,
        amount: this.amount,
      };
      this.$store.dispatch("loadCardDetail", payload);
    },
  },
};
</script>
<style scoped>
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.init {
  margin-left: 15px;
}
.padd {
  padding: 10px;
  border-radius: 10px;
}
.bankT {
  text-align: center;
  color: #ad1684;
}
.btn {
  background-color: #ad1684 !important;
  text-transform: none;
}
.select {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #e3e3e3;
}
.selectDiv {
  position: relative;
  margin-bottom: 10px;
}
.selectarrow {
  position: absolute;
  top: 15px;
  right: 10px;
  background-color: #ad1684;
}
.selected {
  text-transform: uppercase !important;
}

.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  display: flex;
  justify-content: center;
  padding: 50px;
  padding-top: 20px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.bg1 {
  background-color: rgba(187, 107, 217, 0.3);
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
  cursor: pointer;
}
.card1 {
  display: flex;
  flex-direction: column;
  padding: 30px;
}
.card0 {
  padding: 30px;
  width: 500px;
  border-radius: 15px !important;
}
.card0 h4 {
  margin-left: 30px;
}
.cardv {
  height: 450px;
}
.cardRR {
  height: 300px;
  overflow: scroll;
  padding-bottom: 10px;
}
.init {
  margin-left: 15px;
}
.cardDiv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px !important;
  background-color: rgba(189, 36, 91, 0.1);
}
.network {
  cursor: pointer;
}
.flag {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flag img {
  margin-right: 3px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}

@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }
  img {
    width: 40px;
    height: 40px;
  }
  .card0 {
    padding: 10px;
    border-radius: 15px !important;
  }
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 30px;
    padding-top: 70px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
